import * as React from 'react';
export var IcPlay = function () {
    return (React.createElement("svg", { width: '24', height: '24', viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        React.createElement("path", { d: 'M8 5.14V19.14L19 12.14L8 5.14Z', fill: 'black' })));
};
